MenuToolbarDirective.$inject = ['$state', 'auth', '$document', '$rootScope'];
function MenuToolbarDirective($state, auth, $document, $rootScope) {
    return {
        template: require('./views/menu-toolbar.html'),
        link: function (scope, attrs, elem) {
            scope.$state = $state;
            scope.menu_open = false;
            scope.selected = false;
            scope.$watch('$state.current', function (val) {
                if (val.name === 'trips' || val.name === 'trips_edit') {
                    scope.selected = true;
                }
                else {
                    scope.selected = false;
                }
            });
            scope.logout = function () {
                auth.setToken(null);
            };
            scope.toggleMenu = function () {
                scope.menu_open = scope.menu_open === true ? false : true;
            };
            $(document).bind('click', function (event) {
                if (!angular.element(document.querySelector('.dropdown')).find(event.target)[0]) {
                    scope.$apply(function () {
                        scope.menu_open = false;
                    });
                }
            });
        }
    };
}
angular.module('profumo.core.directives.menu-toolbar', [])
    .directive('menuToolbar', MenuToolbarDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/MenuToolbarDirective.ts
// module id = 459
// module chunks = 0